'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _reactBootstrap = require('react-bootstrap');

var _reactCheckboxGroup = require('react-checkbox-group');

var _reactDatepicker = require('react-datepicker');

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactRadioGroup = require('react-radio-group');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

require('react-datepicker/dist/react-datepicker.css');

require('react-select/dist/react-select.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
  Component: FormComponent
  
  Usage: Generates form components with validations

  Functions:
  [1]
  handleChange(object:input, string:type)
    - Assign form fields value to fieldArr state variable on blur event.
  [2]
  checkFieldFlag(object:field):
    - Sets flag value for dependent fields(Whether to show/hide the field)
  [3]
  renderComponents()
    - Returns an array of form components
    - Iterates over metaData props for form fields and maps it to relevant to form field wrapper 
*/

var FormComponent = function (_Component) {
  _inherits(FormComponent, _Component);

  function FormComponent(props) {
    _classCallCheck(this, FormComponent);

    var _this = _possibleConstructorReturn(this, (FormComponent.__proto__ || Object.getPrototypeOf(FormComponent)).call(this, props));

    _this.handleChange = function (input, type) {
      var fieldArr = _this.state.fieldArr;
      fieldArr[input.name] = input.value;

      _this.setState({
        fieldArr: fieldArr
      });
    };

    _this.CheckboxField = function (field) {
      var input = field.input,
          label = field.label,
          type = field.type,
          value = field.value,
          custom = field.custom,
          hide = field.hide,
          errorClassName = field.errorClassName,
          groupClassName = field.groupClassName,
          fieldClassName = field.fieldClassName,
          labelClassName = field.labelClassName,
          _field$meta = field.meta,
          touched = _field$meta.touched,
          error = _field$meta.error;

      var formValue = _this.props.initialValues && _this.props.initialValues[input.name] ? _this.props.initialValues[input.name] : [];

      return _react2.default.createElement(
        'div',
        { className: hide ? "checkbox hide" : groupClassName || "checkbox" },
        _react2.default.createElement(
          _reactCheckboxGroup.CheckboxGroup,
          _extends({}, input, { id: input.name,
            onChange: function onChange(e) {
              var checkInput = { name: input.name, value: e };
              _this.handleChange(checkInput, type);
              _this.props.onFieldBlur(checkInput);
              input.onBlur(e);
            },
            onBlur: function onBlur(e) {
              input.onBlur();
            },
            value: _this.state.fieldArr && _this.state.fieldArr[input.name] ? _this.state.fieldArr[input.name] : formValue }),
          _react2.default.createElement(
            'div',
            { className: label && label.replace(/\s/g, '') },
            label
          ),
          custom.options.map(function (option, i) {
            return _react2.default.createElement(
              'div',
              { className: fieldClassName || "checkbox-field", key: i },
              _react2.default.createElement(_reactCheckboxGroup.Checkbox, { disabled: custom.disabled, id: option.value, value: option.value, name: option.label }),
              _react2.default.createElement('label', { htmlFor: option.value || '' }),
              _react2.default.createElement(
                'div',
                { className: labelClassName || "radio-label" },
                option.label
              )
            );
          })
        ),
        _react2.default.createElement(
          'span',
          { className: errorClassName || 'text-danger is-visible' },
          touched && error && error
        )
      );
    };

    _this.DateField = function (field) {
      var input = field.input,
          label = field.label,
          type = field.type,
          custom = field.custom,
          hide = field.hide,
          errorClassName = field.errorClassName,
          groupClassName = field.groupClassName,
          fieldClassName = field.fieldClassName,
          labelClassName = field.labelClassName,
          calendarClassName = field.calendarClassName,
          _field$meta2 = field.meta,
          touched = _field$meta2.touched,
          error = _field$meta2.error;


      return _react2.default.createElement(
        'div',
        { className: hide ? "form-group hide" : groupClassName || "form-group" },
        _react2.default.createElement(
          'label',
          { className: labelClassName || "label-control", htmlFor: input.name ? input.name : '' },
          label
        ),
        _react2.default.createElement(_reactDatepicker2.default, _extends({}, input, { className: fieldClassName || 'form-control',
          dateFormat: custom.dateFormat,
          disabled: custom.disabled,
          dropdownMode: 'select',
          id: input.name,
          onChange: function onChange(e) {
            input.onBlur(e);
            var dateInput = { name: input.name, value: (0, _moment2.default)(e._d).format(custom.dateFormat) };
            _this.handleChange(dateInput, type);
            _this.props.onFieldBlur(dateInput);
            _this.props.change(input.name, (0, _moment2.default)(e._d).format(custom.dateFormat));
          },
          calendarClassName: calendarClassName,
          disabledKeyboardNavigation: true,
          maxDate: custom.maxDate || custom.maxDate === undefined ? (0, _moment2.default)(custom.maxDate) : null,
          minDate: custom.minDate || custom.minDate === undefined ? (0, _moment2.default)(custom.minDate) : null,
          placeholderText: field.placeholder,
          selected: input.value ? (0, _moment2.default)(input.value, custom.dateFormat) : null,
          showMonthDropdown: true,
          showYearDropdown: true })),
        _react2.default.createElement(
          'span',
          { className: errorClassName || 'text-danger is-visible' },
          touched && error && error
        )
      );
    };

    _this.InputField = function (field) {
      var input = field.input,
          label = field.label,
          type = field.type,
          custom = field.custom,
          errorClassName = field.errorClassName,
          groupClassName = field.groupClassName,
          fieldClassName = field.fieldClassName,
          labelClassName = field.labelClassName,
          hide = field.hide,
          placeholder = field.placeholder,
          _field$meta3 = field.meta,
          touched = _field$meta3.touched,
          error = _field$meta3.error;

      return _react2.default.createElement(
        'div',
        { className: hide ? "form-group hide" : groupClassName || "form-group" },
        _react2.default.createElement(
          'label',
          { className: labelClassName || "label-control", htmlFor: input.name ? input.name : '' },
          label
        ),
        _react2.default.createElement('input', _extends({}, input, { className: fieldClassName || 'form-control', disabled: custom.disabled, id: input.name,
          onBlur: function onBlur(e) {
            input.onBlur(e);
            _this.handleChange(input, type);
            _this.props.onFieldBlur(input);
          }, placeholder: placeholder, type: type })),
        _react2.default.createElement(
          'span',
          { className: errorClassName || 'text-danger is-visible' },
          touched && error && error
        )
      );
    };

    _this.RadiobuttonField = function (field) {
      var input = field.input,
          label = field.label,
          type = field.type,
          errorClassName = field.errorClassName,
          groupClassName = field.groupClassName,
          fieldClassName = field.fieldClassName,
          labelClassName = field.labelClassName,
          custom = field.custom,
          hide = field.hide,
          _field$meta4 = field.meta,
          touched = _field$meta4.touched,
          error = _field$meta4.error;

      var formValue = _this.props.initialValues && _this.props.initialValues[input.name] ? _this.props.initialValues[input.name] : null;

      return _react2.default.createElement(
        'div',
        { className: hide ? "radio hide" : "" },
        _react2.default.createElement(
          _reactRadioGroup.RadioGroup,
          _extends({}, input, { className: groupClassName, id: input.name,
            onChange: function onChange(e) {
              input.onBlur(e);
              var radioInput = { name: input.name, value: e };
              _this.handleChange(radioInput, type);
              _this.props.onFieldBlur(radioInput);
            },
            selectedValue: _this.state.fieldArr && _this.state.fieldArr[input.name] ? _this.state.fieldArr[input.name] : formValue }),
          _react2.default.createElement(
            'div',
            { className: label && label.replace(/\s/g, '') },
            label
          ),
          custom.options.map(function (option, i) {
            return _react2.default.createElement(
              'div',
              { className: fieldClassName || "checkbox-field", key: i },
              _react2.default.createElement(_reactRadioGroup.Radio, { disabled: custom.disabled, id: option.label, value: option.value }),
              _react2.default.createElement(
                'label',
                { htmlFor: option.label || '' },
                ' '
              ),
              _react2.default.createElement(
                'div',
                { className: labelClassName || "radio-label" },
                option.label
              )
            );
          })
        ),
        _react2.default.createElement(
          'span',
          { className: errorClassName || 'text-danger is-visible' },
          touched && error && error
        )
      );
    };

    _this.SelectField = function (field) {
      var input = field.input,
          label = field.label,
          type = field.type,
          custom = field.custom,
          errorClassName = field.errorClassName,
          fieldClassName = field.fieldClassName,
          groupClassName = field.groupClassName,
          labelClassName = field.labelClassName,
          hide = field.hide,
          _field$meta5 = field.meta,
          touched = _field$meta5.touched,
          error = _field$meta5.error;


      return _react2.default.createElement(
        'div',
        { className: hide ? "form-group hide" : groupClassName || "form-group" },
        _react2.default.createElement(
          'label',
          { className: labelClassName || "label-control", htmlFor: input.name ? input.name : '' },
          label
        ),
        custom.customTags ? _react2.default.createElement(_reactSelect.Creatable, _extends({}, input, {
          clearable: false,
          className: fieldClassName || "",
          disabled: custom.disabled,
          inputProps: { id: input.name },
          multi: custom.multi,
          onBlur: function onBlur() {
            input.onBlur(input.value);
            _this.handleChange(input, type);
            _this.props.onFieldBlur(input);
          },
          options: custom.options,
          value: input.value // requires value to be an array 
        })) : _react2.default.createElement(_reactSelect2.default, _extends({}, input, {
          clearable: false,
          className: fieldClassName || "",
          disabled: custom.disabled,
          inputProps: { id: input.name },
          multi: custom.multi,
          onBlur: function onBlur() {
            input.onBlur(input.value);
            _this.handleChange(input, type);
            _this.props.onFieldBlur(input);
          },
          options: custom.options,
          value: input.value // requires value to be an array 
        })),
        _react2.default.createElement(
          'span',
          { className: errorClassName || 'text-danger is-visible' },
          touched && error && error
        )
      );
    };

    _this.TextareaField = function (field) {
      var input = field.input,
          label = field.label,
          type = field.type,
          custom = field.custom,
          errorClassName = field.errorClassName,
          groupClassName = field.groupClassName,
          fieldClassName = field.fieldClassName,
          labelClassName = field.labelClassName,
          hide = field.hide,
          placeholder = field.placeholder,
          _field$meta6 = field.meta,
          touched = _field$meta6.touched,
          error = _field$meta6.error;

      return _react2.default.createElement(
        'div',
        { className: hide ? "form-group hide" : groupClassName || "form-group" },
        _react2.default.createElement(
          'label',
          { className: labelClassName || "label-control", htmlFor: input.name ? input.name : '' },
          label
        ),
        _react2.default.createElement('textarea', _extends({}, input, { className: fieldClassName || 'form-control', disabled: custom.disabled, id: input.name,
          onBlur: function onBlur(e) {
            input.onBlur(e);
            _this.handleChange(input, type);
            _this.props.onFieldBlur(input);
          },
          placeholder: placeholder })),
        _react2.default.createElement(
          'span',
          { className: errorClassName || 'text-danger is-visible' },
          touched && error && error
        )
      );
    };

    _this.checkFieldFlag = function (field) {
      var fieldArr = _this.state.fieldArr;

      if (field.parent) {
        var fieldMap = field.parent.map(function (parent) {
          var flag = false;
          var parentValues = fieldArr[parent.name];

          if (parentValues) {
            if (parent.checkValue) {
              if ((typeof parentValues === 'undefined' ? 'undefined' : _typeof(parentValues)) === 'object') {
                if (Array.isArray(parentValues)) {
                  parentValues.map(function (obj) {
                    flag = parent.parentValues.includes(obj.value);
                    return flag;
                  });
                } else {
                  flag = parent.parentValues.includes(parentValues.value);
                }
              } else {
                flag = parent.parentValues.includes(parentValues);
              }
            } else {
              flag = true;
            }
          }
          return flag;
        });
        return fieldMap.includes(false);
      } else {
        return false;
      }
    };

    _this.WildcardComponent = function (field) {
      return field.custom.component;
    };

    _this.renderComponents = function () {
      var componentMap = {
        'checkbox': _this.CheckboxField,
        'date': _this.DateField,
        'radio': _this.RadiobuttonField,
        'select': _this.SelectField,
        'multiselect': _this.SelectField,
        'textarea': _this.TextareaField,
        'wildcard': _this.WildcardComponent
      };

      var metaData = _this.props.formDefs.metaData;


      var formComponents = metaData.map(function (field, i) {
        var custom = { dateFormat: field.dateFormat, maxDate: field.maxDate, minDate: field.minDate, multi: field.type === 'multiselect' ? true : false, options: field.options, component: field.component, disabled: field.disabled, customTags: field.customTags };
        var groupClassName = void 0,
            fieldClassName = void 0,
            labelClassName = void 0,
            errorClassName = void 0,
            calendarClassName = void 0;
        if (typeof field.className === 'string') {
          groupClassName = field.className;
        } else if (_typeof(field.className) === 'object') {
          errorClassName = field.className.errorClassName;
          groupClassName = field.className.groupClassName;
          fieldClassName = field.className.fieldClassName;
          labelClassName = field.className.labelClassName;
          calendarClassName = field.className.calendarClassName;
        }

        var hide = field.parent && _this.checkFieldFlag(field) ? true : false;
        return _react2.default.createElement(_reduxForm.Field, { key: i, name: field.name, type: field.type,
          component: componentMap[field.type] ? componentMap[field.type] : _this.InputField,
          className: field.className ? field.className : '',
          custom: custom,
          fieldClassName: fieldClassName,
          groupClassName: groupClassName,
          labelClassName: labelClassName,
          errorClassName: errorClassName,
          calendarClassName: calendarClassName,
          hide: hide,
          label: field.label,
          placeholder: field.placeholder,
          validate: field.validation,
          value: field.value
        });
      });

      return formComponents;
    };

    _this.onSubmit = function (payload) {
      var values = Object.assign({}, payload);
      Object.keys(values).map(function (key) {
        if (typeof values[key] === 'string') {
          values[key] = values[key].trim();
        }
      });

      _this.props.onSubmit(values);
    };

    _this.state = {
      fieldArr: {}
    };
    return _this;
  }

  // Checkbox component wrapper


  // Date component wrapper


  // Input component wrapper


  // Radio button wrapper


  // Select/Multi-select dropdown component wrapper


  // Textarea component wrapper


  // Render for form components


  _createClass(FormComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          formDefs = _props.formDefs,
          handleSubmit = _props.handleSubmit,
          valid = _props.valid,
          disableBtn = _props.disableBtn;
      var submitButton = formDefs.submitButton,
          closeButton = formDefs.closeButton;


      var field = void 0,
          groupClassName = void 0,
          fieldClassName = void 0;
      if (submitButton) field = submitButton;else field = closeButton;

      if (typeof field.className === 'string') {
        fieldClassName = field.className;
      } else if (_typeof(field.className) === 'object') {
        groupClassName = field.className.groupClassName;
        fieldClassName = field.className.fieldClassName;
      }
      return _react2.default.createElement(
        'form',
        { onSubmit: handleSubmit(this.onSubmit) },
        this.renderComponents(),
        _react2.default.createElement(
          _reactBootstrap.ButtonToolbar,
          { className: groupClassName ? submitButton.className.groupClassName : '' },
          !!!submitButton.hide && _react2.default.createElement(
            'button',
            { className: submitButton.className.fieldClassName || "btn btn-primary", disabled: disableBtn ? !valid : disableBtn, id: submitButton.text, type: 'submit' },
            submitButton.text
          ),
          !!!closeButton.hide && _react2.default.createElement(
            'button',
            { className: closeButton.className.fieldClassName || "btn btn-danger", onClick: function onClick() {
                return _this2.props.onClose(_this2.state.fieldArr);
              }, id: closeButton.text, type: 'reset' },
            closeButton.text
          )
        )
      );
    }
  }]);

  return FormComponent;
}(_react.Component);

FormComponent = (0, _reduxForm.reduxForm)({
  form: 'customForm', // a unique identifier for this form
  enableReinitialize: true, // to allow form reinitialization
  destroyOnUnmount: false
})(FormComponent);

function mapDispatchToProps(dispatch) {
  return {};
}

FormComponent = (0, _reactRedux.connect)(function (state) {
  if (Object.keys(state.customForm.formData).length > 0) {
    return {
      initialValues: state.customForm.formData // Sets initial values provided by redux store in form fields
    };
  } else {
    return {};
  }
}, mapDispatchToProps)(FormComponent);

exports.default = FormComponent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dataphi-react-components/dist/Containers/FormScreen/FormComponent/FormComponent.js
// module id = 1753
// module chunks = 0